import type { SVGProps } from 'react';

const SvgAssetTypeVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 5.008H6c-1.65 0-3 1.35-3 3v8c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-8c0-1.65-1.35-3-3-3m1 11c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1h12c.55 0 1 .45 1 1z"
    />
    <path
      fill="currentcolor"
      d="m14.54 11.218-3.6-2.08c-.61-.35-1.38.09-1.38.79v4.16c0 .71.76 1.15 1.38.79l3.6-2.08a.92.92 0 0 0 0-1.59z"
    />
  </svg>
);
export default SvgAssetTypeVideo;
